var React = require('react');

function List (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M32 24H84M32 48H84M32 72H84M12 24H12.04M12 48H12.04M12 72H12.04","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

List.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = List;

List.default = List;
